export default __webpack_public_path__ + "static/media/google-play-badge.921ed66b.png";